import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Tag, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export const SetsSections = () => {
  const [sets, setSets] = useState([]);
  const [brands, setBrands] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/sets").then((r) => setSets(r.data)).catch(() => {});
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
  }, []);

  const brandName = (slug) => brands.find((b) => b.slug === slug)?.name || slug;

  return (
    <>
      {sets.filter((s) => s.products.length > 0).map((s) => (
        <section key={s.id} className="py-20 md:py-28 border-t border-zinc-100" data-testid={`set-section-${s.id}`}>
          <div className="max-w-[1600px] mx-auto px-6 md:px-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7 }}
              className="flex flex-wrap items-end justify-between gap-6 mb-14"
            >
              <div>
                <p className="text-xs uppercase tracking-[0.5em] text-gold mb-4">Curated Set</p>
                <h2 className="font-serif font-medium text-4xl sm:text-5xl text-zinc-900 tracking-tight">{s.title}</h2>
                {s.subtitle && <p className="text-zinc-500 mt-3 max-w-xl">{s.subtitle}</p>}
              </div>
              {s.offer_type === "coupon" && s.coupon_code && (
                <button
                  onClick={() => navigate("/offers")}
                  data-testid={`set-offer-${s.id}`}
                  className="flex items-center gap-2.5 border border-gold/40 text-gold text-[10px] uppercase tracking-[0.25em] px-6 py-3.5 hover:bg-gold hover:text-white transition-colors duration-300"
                >
                  <Tag size={13} /> Use code {s.coupon_code}
                </button>
              )}
              {s.offer_type === "link" && s.link && (
                <button
                  onClick={() => navigate(s.link)}
                  data-testid={`set-offer-${s.id}`}
                  className="group flex items-center gap-2.5 bg-gold text-white text-[10px] uppercase tracking-[0.25em] px-6 py-3.5 hover:bg-champagne transition-colors duration-300"
                >
                  View Offer <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
                </button>
              )}
            </motion.div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-10">
              {s.products.slice(0, 8).map((p, i) => (
                <ProductCard key={p.id} product={p} brandName={brandName(p.brand_slug)} index={i} />
              ))}
            </div>
          </div>
        </section>
      ))}
    </>
  );
};
